





























































import {Component, Prop, Vue, Emit, Watch, Model} from "vue-property-decorator";
import {EMPTY_ARRAY} from "@/lib/appconst";

let tempInputValue = '';

@Component({name: 'searchInput'})
export default class searchInput extends Vue {
    @Prop({type: Array, default: EMPTY_ARRAY}) dataSources?: any[];
    @Prop({type: String, default: ''}) placeholder?: string;
    @Prop({type: String, default: ''}) enterButton?: string;
    @Prop({type: String, default: 'default'}) size?: string;
    @Prop({type: Boolean, default: false}) isAutoComplete?: boolean;
    @Model('change', {type: String, default: ''}) inputVal?: string;

    // defValue: string = this.inputVal;
    value: string = this.inputVal;
    items: any[] = [];

    //补全搜索
    onSearch(inputVal: string) {
        tempInputValue = inputVal;
        this.items = [];
        if (this.dataSources.length > 0 && tempInputValue) {
            let allItems = [...this.dataSources] || [];
            this.items = allItems.filter((item: string) => item.indexOf(tempInputValue) > -1);
        } else {
            this.handleAutoComplete(tempInputValue);
        }
    }

    handleSearch() {
        //去除两端的空字符
        let inputVal: string = this.value.trim();
        if (!inputVal) {
            this.value = '';
        }
        this.handleSearchBase(inputVal);
    }

    //高亮显示
    highlightText(text: string = '') {
        return text.toString().replace(tempInputValue, `<span style="color:#dd4b39;"> ${tempInputValue} </span>`);
    }

    @Emit('select')
    handleSelect(index, option) {
        let value: string = this.items[index] || '';
        this.value = value;
        this.handleSearch();
        return value;
    }

    @Emit('search')
    handleSearchBase(inputVal: string) {
        if (!inputVal) {
            this.$message.warning('请输入搜索内容');
        }
        return inputVal;
    }

    //自动补全
    @Emit('autoComplete')
    handleAutoComplete(inputVal: string) {
        return inputVal;
    }

    @Watch('dataSources')
    handelDataSourcesChange(newVal: any[], oldVal: any[]) {
        if (newVal !== oldVal) {
            this.items = newVal || [];
        }
    }

    @Watch('inputVal')
    handelInputChange(newVal: string, oldVal: string) {
        if (newVal !== oldVal) {
            this.value = newVal;
        }
    }

    @Emit('change')
    handleInputValueChange(value: string) {
        return value;
    }
}
